module.exports = __webpack_public_path__ + "img/logo.13c8ec2f.png";